import React from "react";
//#region types
import { FormFieldProps } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import { Chip, Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

function SelectionReadonlyField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const { value } = props;

  return value ? (
    <Grid item container className={clsx(cssExports.suggestionsChips, cssExports.selectionChipsGroup)} spacing={1}>
      <Grid item container className={cssExports.selectionChips} spacing={1} direction="row">
        <Grid item>
          <Chip className={clsx(cssExports.chip, cssExports.readonly)} variant="outlined" label={value} />
        </Grid>
      </Grid>
    </Grid>
  ) : null;
}

export default SelectionReadonlyField;
